import { Page } from '@app/components/page/Page';
import { ComposeIcon } from '@app/modules/compose/components/ComposeIcon';
import { composeRouteGenerator } from '@app/modules/compose/routing/compose-route-generator';
import { LinkItem } from '@mi-front/ui';
import { useIntl } from 'react-intl';
import { useComposition } from '../hooks/useComposition';
import { ComposeViewActions } from './ComposeViewActions';

/**
 * Composition view header: breadcrumbs, Edits and Publish tabs.
 */
export function ComposeViewHeader() {
  const { composition, station } = useComposition();
  const { $t } = useIntl();

  const tabs: LinkItem[] = [
    {
      exact: true,
      to: composeRouteGenerator.edits(composition.id),
      text: $t({
        id: 'compose.videoEditions.tabTitle',
        defaultMessage: 'Edits',
      }),
      isActive: (_match, location) =>
        location.pathname === composeRouteGenerator.edits(composition.id),
    },
    {
      exact: true,
      to: composeRouteGenerator.publish(composition.id),
      text: $t({
        id: 'compose.publish.tabTitle',
        defaultMessage: 'Redes',
      }),
      isActive: (_match, location) =>
        location.pathname === composeRouteGenerator.publish(composition.id),
    },
  ];

  return (
    <Page.Header
      title={composition.name}
      icon={<ComposeIcon />}
      breadcrumbs={
        <Page.Breadcrumbs
          items={[
            {
              icon: <ComposeIcon fontSize="inherit" />,
              content: $t({
                id: 'compose.listScreen.hubLabel',
                defaultMessage: 'Compose',
              }),
            },
            ...(station
              ? [
                  {
                    content: station.name,
                    href: composeRouteGenerator.listForStationSlug(station.slug),
                  },
                ]
              : []),
          ]}
        />
      }
      tabs={tabs}
      actions={<ComposeViewActions />}
    />
  );
}
